import { ECasinoGameViewOrder } from 'interfaces/casino-data';
import { checkIsGameAlreadyCached } from './check-is-game-already-cached';
import {
  constructAndRedirectToGameView,
  IConstructGameViewUrl
} from './construct-view-url';
import {
  decodeGameIdWithPrefix,
  encodeGameIdWithPrefix
} from './encode-game-id-with-prefix';
import {
  extractGameInfoFromSearchParams,
  IGameInfo
} from './extract-game-info-from-search-query';
import { getRouteLength } from './get-route-length';
import { normalizeStringifiedQuery } from './normalize-stringified-query';
import { reconstructAndRedirectToGameView } from './reconstruct-and-redirect-to-game-view';

type TUtilsCasinoProps = {
  checkIsGameAlreadyCached: (gameId: string) => boolean;
  constructAndRedirectToGameView: (props: IConstructGameViewUrl) => void;
  reconstructAndRedirectToGameView: (
    callbackAfterSignin?: () => void,
    routeToSaveInStorage?: string
  ) => void;
  extractGameInfoFromSearchParams: (
    searchParams: Record<string, string | undefined>
  ) => IGameInfo[];
  encodeGameIdWithPrefix: (order: ECasinoGameViewOrder, id: string) => string;
  decodeGameIdWithPrefix: (id: string) => {
    order: number;
    gameId: string | number;
  };
  normalizeStringifiedQuery: (stringifiedQuery: string) => string;
  getRouteLength: () => number | undefined;
};

export const UtilsCasino: TUtilsCasinoProps = {
  checkIsGameAlreadyCached,
  constructAndRedirectToGameView,
  reconstructAndRedirectToGameView,
  extractGameInfoFromSearchParams,
  encodeGameIdWithPrefix,
  decodeGameIdWithPrefix,
  normalizeStringifiedQuery,
  getRouteLength
};
